import React from "react";
import TarjetaProducto from "../Producto/TarjetaProducto";
import Top10Numbers from "../../common/Top10Numbers";
import { useTheme } from "styled-components";
import { NumberContainer, ProductContainer, Top10CardContainer, } from "./Top10CardStyled";
export var Top10Card = function (_a) {
    var products = _a.products, number = _a.number;
    var theme = useTheme();
    return (React.createElement(Top10CardContainer, null,
        React.createElement(NumberContainer, null,
            React.createElement(Top10Numbers, { topNumber: number, color: "transparent", stroke: theme.primarioHover })),
        React.createElement(ProductContainer, null,
            React.createElement(TarjetaProducto, { keyId: products.id, producto: products, contextoVisual: "top10", listsControlActive: false, hideTags: true }))));
};
